import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SystemSalaryFilterEntity } from '../../domain/entities/SystemSalaryFilterEntity'

export class SystemSalaryFilterModel extends SystemSalaryFilterEntity {
  constructor(dataDto: SystemSalaryFilterEntity) {
    super()
    mapEntityProperties<SystemSalaryFilterModel>(this, dataDto)
  }
}
